import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
type Props = {
  hasClicked: boolean;
  onClick: () => void;
};
export function StickyApplyButton({
  hasClicked,
  onClick
}: Props) {
  return <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-50 px-4 w-full max-w-md pointer-events-none" data-id="element-134">
      <AnimatePresence mode="wait" data-id="element-135">
        <motion.button key={hasClicked ? 'clicked' : 'initial'} initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: 10
      }} transition={{
        duration: 0.25
      }} onClick={onClick} className="pointer-events-auto w-full px-6 py-4 bg-maroon text-white font-bold text-base sm:text-lg rounded-full shadow-2xl hover:bg-opacity-90 transition-colors whitespace-nowrap" data-id="element-136">
          {hasClicked ? 'Finish video to see apply link' : 'Apply'}
        </motion.button>
      </AnimatePresence>
    </div>;
}